import { render, staticRenderFns } from "./CreateConnect.vue?vue&type=template&id=767f4e20&"
var script = {}
import style0 from "./CreateConnect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports